import { useCallback } from 'react';

import { CoverageLevelPayload as CoverageLevelStorePayload } from '../CoverageLevels.constants';
import { useStore as useCoverageLevelsStore } from '../stores/useCoverageLevels.store';

export type CoverageLevelPayload = {
  coverageLevels: CoverageLevelStorePayload[];
};

export default () => {
  const setCoverageLevelsStore = useCoverageLevelsStore((state) => state.setState);
  const setSourceCoverageLevelsStore = useCoverageLevelsStore((state) => state.setSourceState);
  const showErrorsCoverageLevelsStore = useCoverageLevelsStore((state) => state.setShowErrors);
  const handleResetCoverageLevelsStore = useCoverageLevelsStore((state) => state.handleReset);
  const setCoveragesLevelsErrors = useCoverageLevelsStore((state) => state.setErrors);

  const handleSetSourceState = useCallback(
    (values: Partial<CoverageLevelPayload>) => {
      if (values.coverageLevels) {
        setSourceCoverageLevelsStore(values.coverageLevels);
      }
    },
    [setSourceCoverageLevelsStore]
  );

  const handleSetState = useCallback(
    (values: Partial<CoverageLevelPayload>) => {
      if (values.coverageLevels) {
        setCoverageLevelsStore(values.coverageLevels);
        handleSetSourceState(values);
      }
    },
    [handleSetSourceState, setCoverageLevelsStore]
  );

  const handleReset = useCallback(() => {
    handleResetCoverageLevelsStore();
  }, [handleResetCoverageLevelsStore]);

  const handleShowErrors = useCallback(
    (value: boolean) => {
      showErrorsCoverageLevelsStore(value);
    },
    [showErrorsCoverageLevelsStore]
  );

  const handleSetErrors = useCallback(
    (values: Partial<CoverageLevelPayload>) => {
      if (values.coverageLevels) {
        setCoveragesLevelsErrors(values.coverageLevels);
      }
    },
    [setCoveragesLevelsErrors]
  );

  return {
    handleReset,
    handleSetState,
    handleSetErrors,
    handleShowErrors,
    handleSetSourceState,
  };
};
